/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { GetExclusiveLinkResponse, IErrorResponse } from '@/types';

import { useQuery } from '@tanstack/react-query';

import { urls } from '@/statics';

const useExclusiveLink = () =>
  useQuery<GetExclusiveLinkResponse, IErrorResponse>({
    queryKey: [urls.getExclusiveLink],
    enabled: false,
  });

export default useExclusiveLink;
